import React from "react"
import styled from "styled-components"


const _NoWalletModal = styled.div`
	text-align: center;

	overflow: scroll;
	align-self: center;
    color: ${({ theme }) => theme.oracleCurrencySelectorPanelTextColor};
    background-color: ${({ theme }) => theme.oracleCurrencySelectorPanelBackgroundColor};
    border-radius: 0.5em;
    padding: 2em;
    font-size: 2rem;
`;

const _NoWalletModalWrapper = styled.div`
	width:100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	justify-content: center;
`;

const MetamaskLink = styled.a`
	text-decoration: none;
	color: inherited
`

function NoWalletModal(props) {
	return (
		<_NoWalletModal ref={props.handleRef}>
			Get <MetamaskLink href="https://metamask.io" target="_blank">Metamask</MetamaskLink> 😇
		</_NoWalletModal>
	)
}


function NoWalletModalWrapper(props) {
	return (
		<>
			{
				<_NoWalletModalWrapper><NoWalletModal handleRef={props.handleRef} /></_NoWalletModalWrapper>
			}
		</>
	)
}

export default NoWalletModalWrapper;
